import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import AppBar from "components/Layout/AppBar";
import ViewerFrame from "components/Forms/ViewerFrame";
import { useStore } from "_Store";
import { client } from "services/api";
import CampaignBtn from "pages/Cahier/TopHeadBox";
import ReportCart from "./ReportCart";
import { axius,func } from "helpers";

const StockReport = () => {
  const navigate = useNavigate();
  const { state:{activeFarm,activeCampaign} } = useStore();
  const [farmerStock, setFarmerStock] = useState([])
  const [visible, setVisible] = useState(false);
  const [source, setSource] = useState("");
  const [title, setTitle] = useState("");

  useEffect(() => {
    console.log(activeCampaign.id)
    const getStock = async () => {
      const allStock = await axius.get(`report-pdf/getReportPdfs?campaignId=${activeCampaign.id}&target=caisse`)
      setFarmerStock(allStock.data)
    }
    
    getStock()
    
  }, [])

  const downloadFile = (link) => {
    const anchor = document.createElement('a');
    anchor.href = link;
    anchor.target = "_blank";
    anchor.download = true;
    anchor.click();
  };
  const handleReadPdf = (data) => {
    setTitle(data.name)
    setSource(`${func.config.prod.imageBaseUrl}reportPdf/stockSheet/${data.reportFileName}`)
    setVisible(true)
  };
 const handleDownload = (data) => {
  downloadFile(`${func.config.prod.imageBaseUrl}reportPdf/stockSheet/${data.reportFileName}`)
  };

  function getMonthInLetter(date) {
     date = new Date(date); 
    const options = { month: 'long' };
    return date.toLocaleString('fr-FR', options);
  }

  function filterTabByMonth(tab) {
    return tab.reduce((result, item) => {
      const month = new Date(item.createdAt).toLocaleString('fr-FR', { month: 'long' });
      console.log(item, result,month,'***********');
      if (!result[month]) {
        result[month] = [];
      }
      result[month].push(item);
      return result;
    }, {});
  }

  return (
    <>
      <div className="w-full sm:max-w-screen-2xl sm:px-6 mx-auto flex flex-col mt-4">
        <AppBar />
        <CampaignBtn onlyBack />
      </div>
      <Grid className="w-full sm:max-w-screen-2xl sm:px-6 mx-auto flex flex-col mt-4">
        <Box sx={{ flexGrow: 1 }} className="stockReportSection">
          <h4 className="pt-4 mb-4">Liste des rapports de Journal de caisse mensuel</h4>
          {
            farmerStock && farmerStock.length > 0 ? (
              filterTabByMonth(farmerStock) && Object.keys(filterTabByMonth(farmerStock)).length > 0 ? (
                Object.keys(filterTabByMonth(farmerStock)).map(key => (
                  <div key={key}>
                    <div  style={{ fontWeight: "bold"}} className="text-uppercase">{key}</div>
                    {filterTabByMonth(farmerStock)[key].map(res => (
                      <ReportCart
                        key={res.reportFileName}
                        handleDownload={() => handleDownload(res)}
                        handleReadPdf={() => handleReadPdf(res)}
                        month={() => getMonthInLetter(res)}
                        title={res.name}
                      ></ReportCart>
                    ))}
                  </div>
                ))
              ) : null
            ) : <div style={{ color:"orange", fontWeight:"bold" }}> Aucun rapport disponible </div>
          }
        </Box>
      </Grid>
      <ViewerFrame
                source={source}
                visible={visible}
                onCancel={()=>{
                  setVisible(false)
                }}
                title={title}
            />
    </>
  );
};

export default StockReport;
